import { useState } from "react";
import { Modal } from "react-bootstrap";

const SelectLocationModal = ({ selectedChefData, show, handleClose, locations, handleSelectedLoc }) => {
  const [selectedKitchen, setSelectedKitchen] = useState(selectedChefData ? selectedChefData : "");

  const handleSelectChange = (e) => {
    const selectedLocation = locations.find(
      (loc) => loc.podName === e.target.value
    );
    setSelectedKitchen(selectedLocation);
    handleSelectedLoc(selectedLocation);
  };

  return (
    <Modal show={show} backdrop="static" centered>
      <Modal.Header>
        <Modal.Title>Select Kitchen Location</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="locationSelect" className="form-label fw-bold">
            Choose a Location:
          </label>
          <select
            id="locationSelect"
            className="form-select"
            value={selectedKitchen?.podName || ""}
            onChange={handleSelectChange}
          >
            <option value="">-- Select/UnSelect Location --</option>
            {locations.map((loc) => (
              <option key={loc.podID} value={loc.podName}>
                {loc.podName}
              </option>
            ))}
          </select>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectLocationModal;
